module.exports = __webpack_public_path__ + "static/img/headGif.b2fc503.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/home/headGif.gif
// module id = k9h3
// module chunks = 51